import type { ReactNode } from "react";

type Tone = "ink" | "white";
type Align = "center" | "left";

interface SectionHeadingProps {
	eyebrow?: ReactNode;
	title: ReactNode;
	titleAccent?: ReactNode;
	description?: ReactNode;
	align?: Align;
	tone?: Tone;
	className?: string;
}

export function SectionHeading({
	eyebrow,
	title,
	titleAccent,
	description,
	align = "center",
	tone = "ink",
	className = "",
}: SectionHeadingProps) {
	const isInk = tone === "ink";
	const alignment = align === "center" ? "items-center text-center" : "items-start text-left";

	return (
		<div className={`flex flex-col gap-5 ${alignment} ${className}`}>
			{eyebrow}
			<h2
				className={`text-balance text-3xl font-semibold tracking-tight sm:text-4xl md:text-5xl ${isInk ? "text-foreground" : "text-white"}`}
			>
				{title}
				{titleAccent ? (
					<>
						{" "}
						<span className={isInk ? "landing-text-gradient-brand" : "landing-text-gradient-hero"}>{titleAccent}</span>
					</>
				) : null}
			</h2>
			{description ? (
				<p className={`max-w-2xl text-balance text-base sm:text-lg ${isInk ? "text-foreground/60" : "text-white/70"}`}>{description}</p>
			) : null}
		</div>
	);
}
